import React from 'react'
import { connect } from 'react-redux'
import _ from 'underscore'

import { Entity } from '../app/entity'
import Navigator from '../app/navigator'

import { TidewaysContext } from '../app/context'
import { Snapshot } from '../domain/Snapshot'
import Loading from '../helper/loading'
import LoadingCover from '../helper/loadingCover'
import { ApplicationState } from '../redux/ApplicationState'
import ExternalCallsGraph from './external-calls-graph'
import ExternalOperation from './external-operation'
import Introspection from './Introspection'
import SnapshotNavigation from './snapshot-navigation'
import SnapshotModel from './snapshot/snapshotModel'

interface StateProps {
    tidewaysContext: TidewaysContext
    navigator: Navigator
    parameters: { [key: string]: string }
    data: Snapshot | null
    loading: boolean
}

interface OwnProps {
    showGraph: boolean
}

type Props = StateProps & OwnProps

class ExternalSnapshot extends React.Component<Props> {
    public static defaultProps = {
        showGraph: true,
        loading: false,
        data: null,
    }

    public render() {
        const snapshot = SnapshotModel.fromParameters(this.props.parameters)

        return (
            <>
                <SnapshotNavigation activeType={'external'} />
                <div className="row operation-list">
                    {this.props.showGraph ? (
                        <div className="col-md-12 monitor application-graph jquery-tooltip-reference">
                            <ExternalCallsGraph responseType="95p" />
                        </div>
                    ) : null}

                    <div className="col-lg-12">
                        {this.props.data ? (
                            <div className="box">
                                <Introspection data={this.props.data} snapshot={snapshot} />
                                <div className="box-body no-padding">
                                    {this.props.loading ? <LoadingCover /> : null}
                                    <table className="table table-striped profile">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th style={{ width: 120 }} className="number">
                                                    Requests
                                                </th>
                                                <th style={{ width: 160 }} className="number">
                                                    Average Response
                                                </th>
                                                <th style={{ width: 160 }} className="number">
                                                    Slowest Response
                                                </th>
                                                <th style={{ width: 100 }} className="number">
                                                    Failures
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.data.transactions ? (
                                                _.map(this.props.data.transactions, (operation, id) => {
                                                    return (
                                                        <ExternalOperation
                                                            key={id}
                                                            operation={operation}
                                                            full
                                                            parameters={snapshot.toParameters()}
                                                        />
                                                    )
                                                })
                                            ) : (
                                                <tr>
                                                    <td className="text-center">No transactions occurred in selected period.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : (
                            <Loading {...this.props} title="Introspection" height={100} />
                        )}
                    </div>
                </div>
            </>
        )
    }
}

export default connect<StateProps>((globalState: ApplicationState, props) => {
    const snapshot = globalState.snapshots.snapshot || new Entity()

    return {
        tidewaysContext: globalState.tidewaysContext,
        navigator: new Navigator(globalState.tidewaysContext.route),
        parameters: globalState.tidewaysContext.route.parameters,
        ...snapshot,
    }
})(ExternalSnapshot)
